import { DollarCircleOutlined } from '@ant-design/icons';

import SettlementPage from '../pages/SettlementPage/SettlementPage';

import { SiteMap } from './index';

export const settlementRoutes: SiteMap = {
  settlement: {
    title: '정산 관리',
    page: SettlementPage,
    key: '/settlement',
    role: ['admin'],
    icon: <DollarCircleOutlined />,
    children: [
      {
        label: '청구서',
        icon: null,
        key: '/settlement/invoice',
        role: ['admin'],
      },
      {
        label: '매장별 상세',
        icon: null,
        key: '/settlement/store',
        role: ['admin'],
      },
      {
        label: '지난 내역',
        icon: null,
        key: '/settlement/history',
        role: ['admin'],
      },
      {
        label: '청구서 메시지',
        icon: null,
        key: '/settlement/message',
        role: ['admin'],
      },
    ],
  },
};
